// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file validation_service.proto (package pipeex.validation.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { StartOperationResponseSchema } from "./revit_service_pb";
import { file_revit_service } from "./revit_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file validation_service.proto.
 */
export const file_validation_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_revit_service]);

/**
 * @generated from message pipeex.validation.v1.StandardResult
 */
export type StandardResult = Message<"pipeex.validation.v1.StandardResult"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.validation.v1.StandardResult.
 * Use `create(StandardResultSchema)` to create a new message.
 */
export const StandardResultSchema: GenMessage<StandardResult> = /*@__PURE__*/
  messageDesc(file_validation_service, 0);

/**
 * @generated from message pipeex.validation.v1.GetAvailableValidationsRequest
 */
export type GetAvailableValidationsRequest = Message<"pipeex.validation.v1.GetAvailableValidationsRequest"> & {
};

/**
 * Describes the message pipeex.validation.v1.GetAvailableValidationsRequest.
 * Use `create(GetAvailableValidationsRequestSchema)` to create a new message.
 */
export const GetAvailableValidationsRequestSchema: GenMessage<GetAvailableValidationsRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 1);

/**
 * @generated from message pipeex.validation.v1.ValidationDefinition
 */
export type ValidationDefinition = Message<"pipeex.validation.v1.ValidationDefinition"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string default_severity = 4;
   */
  defaultSeverity: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * @generated from field: bool is_enabled = 6;
   */
  isEnabled: boolean;

  /**
   * @generated from field: int32 criticality_rank = 7;
   */
  criticalityRank: number;
};

/**
 * Describes the message pipeex.validation.v1.ValidationDefinition.
 * Use `create(ValidationDefinitionSchema)` to create a new message.
 */
export const ValidationDefinitionSchema: GenMessage<ValidationDefinition> = /*@__PURE__*/
  messageDesc(file_validation_service, 2);

/**
 * @generated from message pipeex.validation.v1.GetAvailableValidationsResponse
 */
export type GetAvailableValidationsResponse = Message<"pipeex.validation.v1.GetAvailableValidationsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.validation.v1.ValidationDefinition validations = 3;
   */
  validations: ValidationDefinition[];
};

/**
 * Describes the message pipeex.validation.v1.GetAvailableValidationsResponse.
 * Use `create(GetAvailableValidationsResponseSchema)` to create a new message.
 */
export const GetAvailableValidationsResponseSchema: GenMessage<GetAvailableValidationsResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 3);

/**
 * @generated from message pipeex.validation.v1.ExecuteValidationRequest
 */
export type ExecuteValidationRequest = Message<"pipeex.validation.v1.ExecuteValidationRequest"> & {
  /**
   * JSON-serialized ValidationConfiguration (enabledValidations, flags, etc.)
   *
   * @generated from field: string config_json = 1;
   */
  configJson: string;
};

/**
 * Describes the message pipeex.validation.v1.ExecuteValidationRequest.
 * Use `create(ExecuteValidationRequestSchema)` to create a new message.
 */
export const ExecuteValidationRequestSchema: GenMessage<ExecuteValidationRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 4);

/**
 * @generated from message pipeex.validation.v1.ExecuteValidationResponse
 */
export type ExecuteValidationResponse = Message<"pipeex.validation.v1.ExecuteValidationResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * Full PcfValidationReport serialised as JSON.
   * The report structure is deeply nested (CheckResults → Issues → AdditionalData
   * → Dashboard → StageBreakdown/TopSystems/RecommendedActions) and modelling
   * every leaf as a proto message adds complexity without real benefit — both
   * client and server already work with the JSON shape.
   *
   * @generated from field: string report_json = 3;
   */
  reportJson: string;
};

/**
 * Describes the message pipeex.validation.v1.ExecuteValidationResponse.
 * Use `create(ExecuteValidationResponseSchema)` to create a new message.
 */
export const ExecuteValidationResponseSchema: GenMessage<ExecuteValidationResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 5);

/**
 * @generated from message pipeex.validation.v1.GetLastReportRequest
 */
export type GetLastReportRequest = Message<"pipeex.validation.v1.GetLastReportRequest"> & {
};

/**
 * Describes the message pipeex.validation.v1.GetLastReportRequest.
 * Use `create(GetLastReportRequestSchema)` to create a new message.
 */
export const GetLastReportRequestSchema: GenMessage<GetLastReportRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 6);

/**
 * @generated from message pipeex.validation.v1.GetLastReportResponse
 */
export type GetLastReportResponse = Message<"pipeex.validation.v1.GetLastReportResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: bool has_report = 3;
   */
  hasReport: boolean;

  /**
   * @generated from field: string report_json = 4;
   */
  reportJson: string;

  /**
   * @generated from field: string last_validation_date = 5;
   */
  lastValidationDate: string;

  /**
   * @generated from field: string last_validation_captured_at_utc = 6;
   */
  lastValidationCapturedAtUtc: string;

  /**
   * @generated from field: string last_validation_captured_at_local = 7;
   */
  lastValidationCapturedAtLocal: string;
};

/**
 * Describes the message pipeex.validation.v1.GetLastReportResponse.
 * Use `create(GetLastReportResponseSchema)` to create a new message.
 */
export const GetLastReportResponseSchema: GenMessage<GetLastReportResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 7);

/**
 * @generated from message pipeex.validation.v1.GetDocumentInfoRequest
 */
export type GetDocumentInfoRequest = Message<"pipeex.validation.v1.GetDocumentInfoRequest"> & {
};

/**
 * Describes the message pipeex.validation.v1.GetDocumentInfoRequest.
 * Use `create(GetDocumentInfoRequestSchema)` to create a new message.
 */
export const GetDocumentInfoRequestSchema: GenMessage<GetDocumentInfoRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 8);

/**
 * @generated from message pipeex.validation.v1.GetDocumentInfoResponse
 */
export type GetDocumentInfoResponse = Message<"pipeex.validation.v1.GetDocumentInfoResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string document_name = 3;
   */
  documentName: string;

  /**
   * @generated from field: string document_path = 4;
   */
  documentPath: string;
};

/**
 * Describes the message pipeex.validation.v1.GetDocumentInfoResponse.
 * Use `create(GetDocumentInfoResponseSchema)` to create a new message.
 */
export const GetDocumentInfoResponseSchema: GenMessage<GetDocumentInfoResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 9);

/**
 * @generated from message pipeex.validation.v1.GetValidationSettingsRequest
 */
export type GetValidationSettingsRequest = Message<"pipeex.validation.v1.GetValidationSettingsRequest"> & {
};

/**
 * Describes the message pipeex.validation.v1.GetValidationSettingsRequest.
 * Use `create(GetValidationSettingsRequestSchema)` to create a new message.
 */
export const GetValidationSettingsRequestSchema: GenMessage<GetValidationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 10);

/**
 * @generated from message pipeex.validation.v1.UpdateValidationSettingsRequest
 */
export type UpdateValidationSettingsRequest = Message<"pipeex.validation.v1.UpdateValidationSettingsRequest"> & {
  /**
   * @generated from field: double reconnect_gap_margin_millimeters = 1;
   */
  reconnectGapMarginMillimeters: number;
};

/**
 * Describes the message pipeex.validation.v1.UpdateValidationSettingsRequest.
 * Use `create(UpdateValidationSettingsRequestSchema)` to create a new message.
 */
export const UpdateValidationSettingsRequestSchema: GenMessage<UpdateValidationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 11);

/**
 * @generated from message pipeex.validation.v1.ValidationSettingsResponse
 */
export type ValidationSettingsResponse = Message<"pipeex.validation.v1.ValidationSettingsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: double reconnect_gap_margin_millimeters = 3;
   */
  reconnectGapMarginMillimeters: number;

  /**
   * @generated from field: double default_reconnect_gap_margin_millimeters = 4;
   */
  defaultReconnectGapMarginMillimeters: number;

  /**
   * @generated from field: double min_reconnect_gap_margin_millimeters = 5;
   */
  minReconnectGapMarginMillimeters: number;

  /**
   * @generated from field: double max_reconnect_gap_margin_millimeters = 6;
   */
  maxReconnectGapMarginMillimeters: number;
};

/**
 * Describes the message pipeex.validation.v1.ValidationSettingsResponse.
 * Use `create(ValidationSettingsResponseSchema)` to create a new message.
 */
export const ValidationSettingsResponseSchema: GenMessage<ValidationSettingsResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 12);

/**
 * @generated from message pipeex.validation.v1.HighlightElementsRequest
 */
export type HighlightElementsRequest = Message<"pipeex.validation.v1.HighlightElementsRequest"> & {
  /**
   * @generated from field: repeated int64 element_ids = 1;
   */
  elementIds: bigint[];
};

/**
 * Describes the message pipeex.validation.v1.HighlightElementsRequest.
 * Use `create(HighlightElementsRequestSchema)` to create a new message.
 */
export const HighlightElementsRequestSchema: GenMessage<HighlightElementsRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 13);

/**
 * @generated from message pipeex.validation.v1.HighlightElementsResponse
 */
export type HighlightElementsResponse = Message<"pipeex.validation.v1.HighlightElementsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message pipeex.validation.v1.HighlightElementsResponse.
 * Use `create(HighlightElementsResponseSchema)` to create a new message.
 */
export const HighlightElementsResponseSchema: GenMessage<HighlightElementsResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 14);

/**
 * @generated from message pipeex.validation.v1.ExportReportRequest
 */
export type ExportReportRequest = Message<"pipeex.validation.v1.ExportReportRequest"> & {
};

/**
 * Describes the message pipeex.validation.v1.ExportReportRequest.
 * Use `create(ExportReportRequestSchema)` to create a new message.
 */
export const ExportReportRequestSchema: GenMessage<ExportReportRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 15);

/**
 * @generated from message pipeex.validation.v1.ExportReportResponse
 */
export type ExportReportResponse = Message<"pipeex.validation.v1.ExportReportResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;
};

/**
 * Describes the message pipeex.validation.v1.ExportReportResponse.
 * Use `create(ExportReportResponseSchema)` to create a new message.
 */
export const ExportReportResponseSchema: GenMessage<ExportReportResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 16);

/**
 * @generated from message pipeex.validation.v1.ApplyQuickFixRequest
 */
export type ApplyQuickFixRequest = Message<"pipeex.validation.v1.ApplyQuickFixRequest"> & {
  /**
   * JSON-serialized fix data (QuickFixRequest shape from C#)
   *
   * @generated from field: string fix_data_json = 1;
   */
  fixDataJson: string;
};

/**
 * Describes the message pipeex.validation.v1.ApplyQuickFixRequest.
 * Use `create(ApplyQuickFixRequestSchema)` to create a new message.
 */
export const ApplyQuickFixRequestSchema: GenMessage<ApplyQuickFixRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 17);

/**
 * @generated from message pipeex.validation.v1.ApplyQuickFixResponse
 */
export type ApplyQuickFixResponse = Message<"pipeex.validation.v1.ApplyQuickFixResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.validation.v1.ApplyQuickFixResponse.
 * Use `create(ApplyQuickFixResponseSchema)` to create a new message.
 */
export const ApplyQuickFixResponseSchema: GenMessage<ApplyQuickFixResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 18);

/**
 * @generated from message pipeex.validation.v1.GetQuickFixResultRequest
 */
export type GetQuickFixResultRequest = Message<"pipeex.validation.v1.GetQuickFixResultRequest"> & {
};

/**
 * Describes the message pipeex.validation.v1.GetQuickFixResultRequest.
 * Use `create(GetQuickFixResultRequestSchema)` to create a new message.
 */
export const GetQuickFixResultRequestSchema: GenMessage<GetQuickFixResultRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 19);

/**
 * @generated from message pipeex.validation.v1.GetQuickFixResultResponse
 */
export type GetQuickFixResultResponse = Message<"pipeex.validation.v1.GetQuickFixResultResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * "pending" | "completed"
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string result_json = 4;
   */
  resultJson: string;
};

/**
 * Describes the message pipeex.validation.v1.GetQuickFixResultResponse.
 * Use `create(GetQuickFixResultResponseSchema)` to create a new message.
 */
export const GetQuickFixResultResponseSchema: GenMessage<GetQuickFixResultResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 20);

/**
 * @generated from message pipeex.validation.v1.ReconnectElementsRequest
 */
export type ReconnectElementsRequest = Message<"pipeex.validation.v1.ReconnectElementsRequest"> & {
  /**
   * @generated from field: int64 element_id_1 = 1;
   */
  elementId1: bigint;

  /**
   * @generated from field: int64 element_id_2 = 2;
   */
  elementId2: bigint;
};

/**
 * Describes the message pipeex.validation.v1.ReconnectElementsRequest.
 * Use `create(ReconnectElementsRequestSchema)` to create a new message.
 */
export const ReconnectElementsRequestSchema: GenMessage<ReconnectElementsRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 21);

/**
 * @generated from message pipeex.validation.v1.ReconnectElementsResponse
 */
export type ReconnectElementsResponse = Message<"pipeex.validation.v1.ReconnectElementsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message pipeex.validation.v1.ReconnectElementsResponse.
 * Use `create(ReconnectElementsResponseSchema)` to create a new message.
 */
export const ReconnectElementsResponseSchema: GenMessage<ReconnectElementsResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 22);

/**
 * @generated from message pipeex.validation.v1.ReconnectAllPairsRequest
 */
export type ReconnectAllPairsRequest = Message<"pipeex.validation.v1.ReconnectAllPairsRequest"> & {
  /**
   * @generated from field: int32 validation_id = 1;
   */
  validationId: number;
};

/**
 * Describes the message pipeex.validation.v1.ReconnectAllPairsRequest.
 * Use `create(ReconnectAllPairsRequestSchema)` to create a new message.
 */
export const ReconnectAllPairsRequestSchema: GenMessage<ReconnectAllPairsRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 23);

/**
 * @generated from message pipeex.validation.v1.ReconnectAllPairsResponse
 */
export type ReconnectAllPairsResponse = Message<"pipeex.validation.v1.ReconnectAllPairsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.validation.v1.ReconnectAllPairsResponse.
 * Use `create(ReconnectAllPairsResponseSchema)` to create a new message.
 */
export const ReconnectAllPairsResponseSchema: GenMessage<ReconnectAllPairsResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 24);

/**
 * @generated from message pipeex.validation.v1.GetReconnectionResultRequest
 */
export type GetReconnectionResultRequest = Message<"pipeex.validation.v1.GetReconnectionResultRequest"> & {
};

/**
 * Describes the message pipeex.validation.v1.GetReconnectionResultRequest.
 * Use `create(GetReconnectionResultRequestSchema)` to create a new message.
 */
export const GetReconnectionResultRequestSchema: GenMessage<GetReconnectionResultRequest> = /*@__PURE__*/
  messageDesc(file_validation_service, 25);

/**
 * @generated from message pipeex.validation.v1.GetReconnectionResultResponse
 */
export type GetReconnectionResultResponse = Message<"pipeex.validation.v1.GetReconnectionResultResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * "pending" | "completed"
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string result_json = 4;
   */
  resultJson: string;
};

/**
 * Describes the message pipeex.validation.v1.GetReconnectionResultResponse.
 * Use `create(GetReconnectionResultResponseSchema)` to create a new message.
 */
export const GetReconnectionResultResponseSchema: GenMessage<GetReconnectionResultResponse> = /*@__PURE__*/
  messageDesc(file_validation_service, 26);

/**
 * PCF validation, reporting, quick-fix and connector reconnection.
 * Replaces the WebView2 RevitBridge.ValidationBridgeApi surface.
 *
 * @generated from service pipeex.validation.v1.ValidationService
 */
export const ValidationService: GenService<{
  /**
   * List available validation checks that can be enabled/disabled
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.GetAvailableValidations
   */
  getAvailableValidations: {
    methodKind: "unary";
    input: typeof GetAvailableValidationsRequestSchema;
    output: typeof GetAvailableValidationsResponseSchema;
  },
  /**
   * Run validation with selected checks and return full report
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.ExecuteValidation
   */
  executeValidation: {
    methodKind: "unary";
    input: typeof ExecuteValidationRequestSchema;
    output: typeof ExecuteValidationResponseSchema;
  },
  /**
   * Start validation as a host operation with live progress.
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.StartValidationRun
   */
  startValidationRun: {
    methodKind: "unary";
    input: typeof ExecuteValidationRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Return cached report from last validation run (no re-execution)
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.GetLastReport
   */
  getLastReport: {
    methodKind: "unary";
    input: typeof GetLastReportRequestSchema;
    output: typeof GetLastReportResponseSchema;
  },
  /**
   * Retrieve active document metadata (name, path, etc.)
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.GetDocumentInfo
   */
  getDocumentInfo: {
    methodKind: "unary";
    input: typeof GetDocumentInfoRequestSchema;
    output: typeof GetDocumentInfoResponseSchema;
  },
  /**
   * Read session-scoped validation settings. Values reset when Revit/plugin restarts.
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.GetValidationSettings
   */
  getValidationSettings: {
    methodKind: "unary";
    input: typeof GetValidationSettingsRequestSchema;
    output: typeof ValidationSettingsResponseSchema;
  },
  /**
   * Update session-scoped validation settings. Values reset when Revit/plugin restarts.
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.UpdateValidationSettings
   */
  updateValidationSettings: {
    methodKind: "unary";
    input: typeof UpdateValidationSettingsRequestSchema;
    output: typeof ValidationSettingsResponseSchema;
  },
  /**
   * Highlight elements in Revit viewport by their IDs
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.HighlightElements
   */
  highlightElements: {
    methodKind: "unary";
    input: typeof HighlightElementsRequestSchema;
    output: typeof HighlightElementsResponseSchema;
  },
  /**
   * Export last validation report as JSON string
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.ExportReportJson
   */
  exportReportJson: {
    methodKind: "unary";
    input: typeof ExportReportRequestSchema;
    output: typeof ExportReportResponseSchema;
  },
  /**
   * Export last validation report as HTML string
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.ExportReportHtml
   */
  exportReportHtml: {
    methodKind: "unary";
    input: typeof ExportReportRequestSchema;
    output: typeof ExportReportResponseSchema;
  },
  /**
   * Apply a quick-fix to elements (async — queues ExternalEvent)
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.ApplyQuickFix
   */
  applyQuickFix: {
    methodKind: "unary";
    input: typeof ApplyQuickFixRequestSchema;
    output: typeof ApplyQuickFixResponseSchema;
  },
  /**
   * Start quick-fix as a host operation with live progress.
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.StartApplyQuickFix
   */
  startApplyQuickFix: {
    methodKind: "unary";
    input: typeof ApplyQuickFixRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Poll result of previously queued quick-fix
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.GetQuickFixResult
   */
  getQuickFixResult: {
    methodKind: "unary";
    input: typeof GetQuickFixResultRequestSchema;
    output: typeof GetQuickFixResultResponseSchema;
  },
  /**
   * Reconnect a single pair of disconnected elements
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.ReconnectElements
   */
  reconnectElements: {
    methodKind: "unary";
    input: typeof ReconnectElementsRequestSchema;
    output: typeof ReconnectElementsResponseSchema;
  },
  /**
   * Start single reconnect as a host operation with live progress.
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.StartReconnectElements
   */
  startReconnectElements: {
    methodKind: "unary";
    input: typeof ReconnectElementsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Reconnect all disconnected pairs found by a specific validation check
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.ReconnectAllPairs
   */
  reconnectAllPairs: {
    methodKind: "unary";
    input: typeof ReconnectAllPairsRequestSchema;
    output: typeof ReconnectAllPairsResponseSchema;
  },
  /**
   * Start bulk reconnect as a host operation with live progress.
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.StartReconnectAllPairs
   */
  startReconnectAllPairs: {
    methodKind: "unary";
    input: typeof ReconnectAllPairsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Poll result of previously queued bulk reconnection
   *
   * @generated from rpc pipeex.validation.v1.ValidationService.GetReconnectionResult
   */
  getReconnectionResult: {
    methodKind: "unary";
    input: typeof GetReconnectionResultRequestSchema;
    output: typeof GetReconnectionResultResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_validation_service, 0);

